// The Agent stays mounted, including unsaved fields and its selected resource.
// Editors retain their usual Back/Save navigation; reaching their catalog closes
// this child frame instead of replacing the Agent with that catalog.
export function isResourceCatalog(location) {
  const path = location.pathname.replace(/^\/embed/, "")
  const query = new URLSearchParams(location.search)
  if (["edit", "context_id", "new", "create"].some(key => query.has(key))) return false
  if (["/committee", "/aios"].includes(path)) return true
  return /^\/(?:(?:committee|aios)\/(?:builders\/resources\/)?(?:apps|agents|tools|functions|skills|workflows|context|credentials|mcps)|agents(?:\/(?:skills|tools|context|mcp-servers))?|apps|tools|functions|automations|credentials)\/?$/.test(path)
}

export const AgentResourceFrame = {
  mounted() {
    this.frameWindow = null
    this.closed = false
    this.hasDetail = this.el.dataset?.catalogStart !== "true"
    this.closeIfCatalog = () => {
      try {
        const location = this.el.contentWindow.location
        const catalog = isResourceCatalog(location)
        if (location.pathname && location.pathname !== "blank" && !catalog) this.hasDetail = true
        if (!this.closed && this.hasDetail && catalog) {
          this.closed = true
          this.pushEvent(this.el.dataset?.returnEvent || "close_agent_resource_detail", {})
        }
      } catch (_) { /* A resource cannot drive the Agent across origins. */ }
    }
    this.bindFrame = () => {
      this.unbindFrame()
      try {
        this.frameWindow = this.el.contentWindow
        this.frameWindow.addEventListener("phx:page-loading-stop", this.closeIfCatalog)
        this.frameWindow.addEventListener("popstate", this.closeIfCatalog)
        this.closeIfCatalog()
      } catch (_) { this.frameWindow = null }
    }
    this.unbindFrame = () => {
      if (!this.frameWindow) return
      this.frameWindow.removeEventListener("phx:page-loading-stop", this.closeIfCatalog)
      this.frameWindow.removeEventListener("popstate", this.closeIfCatalog)
      this.frameWindow = null
    }
    this.el.addEventListener("load", this.bindFrame)
    this.bindFrame()
  },
  destroyed() {
    this.el.removeEventListener("load", this.bindFrame)
    this.unbindFrame()
  }
}
